import React from 'react';
import PropTypes from 'prop-types';
import jQuery from 'jquery';

class Modal extends React.Component {
    static propTypes = {
        children: PropTypes.oneOfType([
            PropTypes.arrayOf(PropTypes.node),
            PropTypes.node,
        ]),
        modalProps: PropTypes.shape({
            fixedHeight: PropTypes.bool,
            className: PropTypes.string,
        }),
        onClickOutsideModal: PropTypes.func,
    };

    static defaultProps = {
        children: null,
        onClickOutsideModal: null,
        modalProps: {},
    };

    state = {
        is_open: false,
    };

    // eslint-disable-next-line react/sort-comp
    open(callback) {
        this.setState({ is_open: true }, callback);
    }

    close(callback) {
        this.setState({ is_open: false }, callback);
    }

    // eslint-disable-next-line react/destructuring-assignment
    isOpen = () => this.state.is_open;

    getScrollingTarget = () => {
        const {
            modalProps: { fixedHeight },
        } = this.props;
        if (!fixedHeight || !this.modal_reference) {
            return this.modal_reference;
        }
        return this.modal_reference.querySelector('.m2g-modal-body');
    };

    scrollToBottom = () => {
        const target = this.getScrollingTarget();
        if (!target) {
            return;
        }
        const scroll_position = target.scrollHeight - target.clientHeight;
        target.scrollTop = scroll_position;
    };

    scrollToTop = () => {
        const target = this.getScrollingTarget();
        if (!target) {
            return;
        }
        target.scrollTop = 0;
    };

    scrollElementIntoView = (
        element,
        offsetY = 0,
        force_scroll = false,
        callback = () => {}
    ) => {
        const target = this.getScrollingTarget();
        if (!target) {
            return;
        }

        const $element = jQuery(element);
        const $modal = jQuery(target);

        const elementTopFromTopOfScreen =
            $element.offset().top - $modal.offset().top;
        const elementBottomFromTopOfScreen =
            elementTopFromTopOfScreen + $element.height();

        if (
            force_scroll === false &&
            (elementTopFromTopOfScreen > 0 &&
                elementBottomFromTopOfScreen < $modal.height())
        ) {
            // Already fully visible on the screen
            callback();
            return;
        }

        const scrollTopTarget =
            target.scrollTop + elementTopFromTopOfScreen + offsetY;

        if (Mobi2Go.app.disable_animation) {
            $modal.scrollTop(scrollTopTarget);
            callback();
        } else {
            $modal.animate({ scrollTop: scrollTopTarget }, callback);
        }
    };

    /**
     * This is responsible for deciding whether a click outside the
     * modal should result in a close event.
     *
     * A click is consider outside the modal only if the mouse was pressed
     * and released outside the modal.
     *
     * This prevents closing the modal when you press outside the modal
     * and release inside it.
     * This prevents the opposite as well, when you press inside the modal
     * and release outside of it.
     */
    onClickOutsideModal = e => {
        const { allow_overlay_click } = this;
        this.allow_overlay_click = false;

        if (document.elementFromPoint) {
            const elementFromClickCoordinates = document.elementFromPoint(
                e.clientX,
                e.clientY
            );
            if (
                elementFromClickCoordinates !== null &&
                elementFromClickCoordinates !== this.modal_reference &&
                elementFromClickCoordinates !==
                    this.modal_floating_container_reference
            ) {
                return;
            }
        }
        if (
            !allow_overlay_click ||
            (e.target !== this.modal_reference &&
                e.target !== this.modal_floating_container_reference)
        ) {
            return;
        }
        const { onClickOutsideModal } = this.props;
        if (onClickOutsideModal) {
            onClickOutsideModal();
        }
    };

    onMouseDownOutsideModal = e => {
        if (
            e.target !== this.modal_reference &&
            e.target !== this.modal_floating_container_reference
        ) {
            return;
        }

        this.allow_overlay_click = true;
    };

    render() {
        const { children, modalProps } = this.props;
        const { is_open } = this.state;

        const { fixedHeight, className, ...restModalProps } = modalProps;

        return (
            <div
                role="presentation"
                className={`m2g-external-modal ${
                    is_open
                        ? 'm2g-external-modal--modal-open'
                        : 'm2g-external-modal--modal-closed'
                }`}
                onClick={this.onClickOutsideModal}
                onMouseDown={this.onMouseDownOutsideModal}
                ref={ref => {
                    this.modal_reference = ref;
                }}
            >
                <div
                    className="m2g-external-modal-floating-container"
                    ref={ref => {
                        this.modal_floating_container_reference = ref;
                    }}
                >
                    <div
                        role="presentation"
                        {...restModalProps}
                        className={`m2g-modal ${
                            fixedHeight ? 'm2g-modal--fixed-height' : ''
                        } ${className || ''}`}
                        onMouseDown={() => {
                            this.allow_overlay_click = false;
                        }}
                    >
                        {children}
                    </div>
                </div>
            </div>
        );
    }
}

export default Modal;
